import React from "react";
import Navbar from "../components/Navbar";
import "../styles/global.css";
import Footer from "../components/Footer";
import Certification from "../components/Certification";
import { Helmet } from "react-helmet-async";

const CertificatePage = () => {
  return (
    <>
      <Helmet>
        <title>Certifications | TimeWatch Infocom</title>
        <meta
          name="description"
          content="Explore the certifications and accreditations earned by TimeWatch Infocom, a leader in biometric solutions, access control systems, and smart security technology. Our recognized certifications in security solutions, time attendance systems, and entrance automation demonstrate our commitment to quality, innovation, and industry standards. Learn more about our trusted expertise in providing reliable, cutting-edge security technologies for businesses and organizations. Our certified products and services reflect our dedication to excellence and customer satisfaction in the security industry."
        />
        <link rel="canonical" href="https://www.timewatchindia.com/certifications" />
      </Helmet>
      <header className="navbar">
        <Navbar />
      </header>

      <div className="content-container">
        <section className="certficate">
          <Certification />
        </section>
      </div>
      <footer className="footer">
        <Footer />
      </footer>
    </>
  );
};

export default CertificatePage;
